import { useQuery } from "@tanstack/react-query";
import { api, baseUrl } from "./config";

export type AvailableInstrument = {
	id: string;
	name: string;
};

type AvailableInstrumentsResponse = {
	clientAge: number;
	receiver: { name: string; email: string };
	instruments: Array<AvailableInstrument>;
};

type UseAvailableInstrumentsParams = { includeIntake: boolean } & (
	| { treatmentId: number | undefined; leadId?: never }
	| { leadId: number | undefined; treatmentId?: never }
);

export const useAvailableInstruments = ({ treatmentId, leadId, includeIntake }: UseAvailableInstrumentsParams) => {
	const query = useQuery({
		queryKey: ["available-instruments", treatmentId, leadId, includeIntake],
		queryFn: () => getAvailableInstruments({ treatmentId, leadId, includeIntake }),
		enabled: !!treatmentId || !!leadId,
	});
	return query;
};

const getAvailableInstruments = async ({
	treatmentId,
	leadId,
	includeIntake,
}: {
	treatmentId: number | undefined;
	leadId: number | undefined;
	includeIntake: boolean;
}) => {
	const { data } = await api({
		method: "GET",
		url: `${baseUrl}/instruments-forms/crm-responses/available`,
		params: { treatment: treatmentId, lead: leadId, includeIntake },
	});
	return data as AvailableInstrumentsResponse;
};
